import { APP_SETTINGS } from "../_constants/actionConstants";

const initialState = {
  fetching: false,
  environmentContext: "CT",
  useClientSidePDFGeneration: true,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_SETTINGS.GET_APP_SETTINGS:
      return { ...state, fetching: true };
    case APP_SETTINGS.GET_APP_SETTINGS_REJECTED:
      return { ...state, fetching: false };

    case APP_SETTINGS.GET_APP_SETTINGS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        version: action.version,
        environmentContext: action.environmentContext,
        useClientSidePDFGeneration:
          action.useClientSidePDFGeneration.toLowerCase() === "true",
        implementationProgram: action.implementationProgram,
      };
    }

    case APP_SETTINGS.CLEAR_APP_SETTINGS:
      return initialState;

    default:
      return state;
  }
};
